export const NavList = [
  {
    label: "Home",
    path: "/",
  },
  {
    label: "About",
    path: "/about",
  },
  {
    label: "Services",
    path: "/services",
  },
  {
    label: "Work Portfolio",
    path: "/work-portfolio",
  },
  {
    label: "Contact Us",
    path: "/contact",
  },
];

export const HeaderBottomList = [
  {
    label: "Kitchen Renovations",
    path: "/kitchen-renovations",
  },
  {
    label: "Bathroom Renovations",
    path: "/bathroom-renovation",
  },
  {
    label: "Basement Renovations",
    path: "/basement-renovation",
  },
  {
    label: "Home Renovations",
    path: "/home-renovation",
  },
];
